import simpleMerger from './simpleMerger';
import { LOAD } from './constants';

const cacheReducer = (reducer: any, merger: any = simpleMerger) => {
    return (state: any, action: any) => reducer(
        action.type === LOAD
            ? merger(state, action.payload)
            : state,
        action
    );
};

export default cacheReducer;
